module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/WeWereFeatured/assets/theWebby-9321138059cc67fc0c88a7e93fca6c4f.png";